// Tagline A/B test. The control tagline ships site-wide; the "v2a" variant is
// served via a special URL (e.g. /?v=v2a) used in mailers, then persisted so the
// visitor keeps seeing it across navigation.

export const TAGLINES = {
  control: "AI is inevitable. Let us help you navigate it.",
  v2a: "Bridging artificial intelligence with human intelligence.",
};

const STORAGE_KEY = "tier1_variant";

export const getActiveVariant = () => {
  try {
    const requested = new URLSearchParams(window.location.search).get("v");
    if (requested && TAGLINES[requested]) {
      window.localStorage.setItem(STORAGE_KEY, requested);
      return requested;
    }
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && TAGLINES[stored]) return stored;
  } catch {
    // localStorage unavailable (private mode) — fall back to control.
  }
  return "control";
};
